module.exports = __webpack_public_path__ + "static/media/HighRisk.e09416d5.svg";